/*******************************************************************
* PAGE        : LoaderComponent
* REMARKS     : Comman Loader Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

import { CircularProgress } from '@mui/material';
import React from 'react';
import './LoaderComponent.css';

function GradientCircularProgress() {
    return (
        <React.Fragment>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        {/* <stop offset="50%" stopColor="#99FF99" /> */}
                        <stop offset="100%" stopColor="#1CB5E0" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size="3rem" />
        </React.Fragment>
    );
}

const LoaderComponent = () => {
    return (<div className="loader-overlay">
        <CircularProgress size="3rem" color='primary' />
        {/* <GradientCircularProgress /> */}
        {/* <LinearProgress /> */}
    </div>)
}

export default LoaderComponent;